export const accountTypes = [
    'admin',
    'IMOBILIARIA',
    'PROPRIETARIO',
    'INQUILINO',
    'CORRETOR'
]